import {
  REQUEST_TRIALS_PHASES,
  RESPONSE_TRIALS_PHASES,
  FAILURE_TRIALS_PHASES
} from "../../actions/types";

const initialState = {
  error: false,
  isLoading: false,
  total: 0,
  results: [],
  isInitialScreen: true,

  filters: {
    phaseSort: {
      field: "total_trials_count",
      order: "desc"
    },
    drugSort: {
      field: "total_trials_count",
      order: "desc"
    },
    study_type: [],
    phase: [],
    terms: [],
    drugs: [],
    operator: "OR",

    conditions: [],
    exclude: [],
    type: { label: "SPONSORS", value: "SPONSORS" },
    last_update_posted: {
      start: "",
      end: ""
    },
    study_first_posted: {
      start: "",
      end: ""
    },
    country: []
  },
  keyword: "",
  totalDrugs: 0,
  drugs: []
};
const setFetching = (state, action) => {
  let filters = action.payload.filters;
  let keyword = action.payload.keyword;
  let isLoading = action.payload.isLoading;

  if (isLoading === false) {
    return {
      ...state,
      isLoading: isLoading,
      error: false,
      filters,
      keyword,
      results: [],
      total: 0,
      totalDrugs: 0,
      drugs: []
    };
  }
  return {
    ...state,
    isLoading: true,
    error: false,
    filters,
    keyword,
    isInitialScreen: false,

  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isFetching: false,
    error: true,
    results: [],
    drugs: [],
    total: 0,
    totalDrugs: 0
  };
};

const setResults = (state, action) => {
  let results = action.payload.results || [];
  let total = action.payload.total || 0;
  let totalDrugs = action.payload.totalDrugs || 0;
  let drugs = action.payload.drugs || [];

  return {
    ...state,
    isLoading: false,
    error: false,
    results,
    total,
    totalDrugs,
    drugs
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_TRIALS_PHASES:
      return setFetching(state, action);
      break;

    case RESPONSE_TRIALS_PHASES:
      return setResults(state, action);

    case FAILURE_TRIALS_PHASES:
      return setFailure(state, action);

    default:
      return state;
      break;
  }
};
